// Dynamic-Injector

DynamicInjector = function () {
  this._landingData = undefined;
  this._symbols = [];
  this._bounceSymbols = [];
  this._postSymbols = [];
  this._stateData = {};

  //////////////////////////////////////
  // New
  this._reelBandData = [];
  this._reelBandDataTemp = [];
  // Jamie - make two reelBandData lists
  // One for master copy
  // Two to contain all symbols swaps (landing symbols and rule breaking symbols)
  // Copy to second list at the start of the spin, make all adjustments and spin through second list
  // Once all 'modified' symbols have been spun through, swap back to master, clear second list ready for next spin
  // I may do this dynamically so only one list is needed but I'll see how it goes
  // Second idea, make the list dynamic so symbols spun through dissapear and new ones are added (Do not add during spin after results are known for obvious reasons)
  this._symbolSelectionWT = undefined;
  this._safeSymbolsWT = undefined;
  this._readyToLand = false;
  this._reelBandSize = 300;
  this._landingSymbols = [];
  this._currentInjectorPosition = 0;
  this._startSpinInjectorPosition = 0;
  this._finalLandIndex = undefined;
  this._reelID = 0; // Jamie - injector shouldn't care what reel it is - used for debugging purposes for now
  this._nudgeReel = false;
  this._appertureSize = 0; // Used as offset for landing symbols
  //////////////////////////////////////

  this.saveState = function () {
    // JAMIE - MUST IMPLEMENT SAVE AND RESTORE STATE
    // Should be largely similar to before but without the madness!
    //Save state
    this._stateData = {};
    let keys = Object.getOwnPropertyNames(this);
    for (let i = 0; i < keys.length; i++) {
      let name = keys[i];
      let type = typeof this[name];
      let isCallback = name.includes("callback") || name.includes("Callback");

      if (type !== "function" && name !== "base" && !isCallback) {
        if (checkForDefined(this[name])) {
          this._stateData[keys[i]] = JSON.parse(JSON.stringify(this[name]));
        } else {
          this._stateData[keys[i]] = undefined;
        }
      }
    }

    // Add the local scope variables above
    this._stateData._landingData = checkForDefined(_landingData)
      ? JSON.parse(JSON.stringify(_landingData))
      : undefined;
    this._stateData._symbols = checkForDefined(_symbols)
      ? JSON.parse(JSON.stringify(_symbols))
      : undefined;
    this._stateData._bounceSymbols = checkForDefined(_bounceSymbols)
      ? JSON.parse(JSON.stringify(_bounceSymbols))
      : undefined;
    this._stateData._postSymbols = checkForDefined(_postSymbols)
      ? JSON.parse(JSON.stringify(_postSymbols))
      : undefined;
    this._stateData._stateData = checkForDefined(_stateData)
      ? JSON.parse(JSON.stringify(_stateData))
      : undefined;
  };

  this.restoreState = function () {
    let keys = Object.keys(_stateData);
    for (let i = 0; i < keys.length; i++) {
      let name = keys[i];
      if (checkForDefined(_stateData[name])) {
        this[name] = JSON.parse(JSON.stringify(_stateData[name]));
      } else {
        this[name] = undefined;
      }
    }

    this._stateData = {};
  };

  this.setWeightingsAndRules = function (symbolWeights, symbolRules) {
    this._symbolSelectionWT = new WeightedTable();
    this._safeSymbolsWT = new WeightedTable();

    for (let i = 0; i < symbolWeights._outcomes.length; i++) {
      this._symbolSelectionWT.addOutcome(
        symbolWeights._outcomes[i].outcome,
        symbolWeights._outcomes[i].chance
      );
    }

    if (symbolRules !== undefined) {
      for (let i = 0; i < symbolRules.length; i++) {
        const rule = symbolRules[i][0];

        for (let j = 0; j < rule.rules.length; j++) {
          this._symbolSelectionWT.addSymbolRules(rule.type, rule.rules[j]);
        }
      }
    }

    for (let i = 0; i < this._symbolSelectionWT._outcomes.length; i++) {
      if (this._symbolSelectionWT._outcomes[i].rules === undefined) {
        this._safeSymbolsWT.addOutcome(
          this._symbolSelectionWT._outcomes[i].outcome,
          this._symbolSelectionWT._outcomes[i].chance
        );
      }
    }

    this.populateReelBand();
  };

  this.prepareInjector = function (
    reelId,
    symbolsStillInWindow,
    nudgeReel,
    appertureSize,
    symbolWeights,
    symbolRules
  ) {
    this._reelID = reelId;
    this._nudgeReel = nudgeReel;
    this._landingSymbols = [];
    this._appertureSize = appertureSize;
    this.setWeightingsAndRules(symbolWeights, symbolRules);
  };

  // This function should be called once on load to populate the reel band
  // Do not call more than once as it adds the current symbols in view
  // and then populates the rest of the reel band with random valid symbols
  // Jamie - think about if we need the sysbolsStillInWindow parameter
  // Essentially are just the losing symbols on load
  this.populateReelBand = function () {
    this._reelBandData = [];
    this._reelBandDataTemp = [];
    this._currentInjectorPosition = 0;

    // -1 represents no symbol and a symbol needs to be placed
    for (let i = 0; i < this._reelBandSize; i++) {
      this._reelBandData.push(-1);
    }

    for (let i = 0; i < this._reelBandSize; i++) {
      this._reelBandData[i] = this.getNextApprovedSymbol();
      this.increaseCurrentInjectorPosition();
    }

    // Reset this back to 0 after band is populated
    this._currentInjectorPosition = 0;

    this._reelBandDataTemp = JSON.parse(JSON.stringify(this._reelBandData));
  };

  // This must be called prior to each spin.
  // As we will know the exact length of the spin now
  // we can just place the land symbols at this position
  this.setStartSpinPosition = function () {
    this._readyToLand = false;
    this._startSpinInjectorPosition = this._currentInjectorPosition;
  };

  // This function should add symbols to the reel band and follow the symbol rules...
  this.getNextApprovedSymbol = function () {
    return this.checkRulesForValidSymbol();
  };

  // ... and this function should just grab the next to display at the top of the reel
  // No rules detection need here as this has already been done
  this.getNextReelBandSymbol = function () {
    let nextSymbol = this._reelBandData[this._currentInjectorPosition];
    this.increaseCurrentInjectorPosition();

    return nextSymbol;
  };

  this.setLandingSymbols = function (landingSymbols) {
    this._landingSymbols = landingSymbols;
  };

  this.increaseCurrentInjectorPosition = function () {
    this._currentInjectorPosition++;

    if (this._currentInjectorPosition >= this._reelBandData.length) {
      this._currentInjectorPosition -= this._reelBandData.length;
    }
  };

  // Just used to tell the spinner what symbols to display on first load
  // This prevents it from showing '0' symbols on the first spin
  this.getSafeSymbol = function () {
    return this._safeSymbolsWT.pickOutcome().outcome;
  };

  // Dynamic spinner calls this to check if it can go into deceleration state...
  // Reintroduce this once symbol spacing rules are in place.
  // Prevent the spinner from decelerating if symbols can't be placed correctly
  this.readyToLand = function () {
    return this._readyToLand;
  };

  this.reachedLandingSymbols = function () {
    // This is a horrible workaround, but nudge symbols are horrible.
    // Can have two indexes depending on whether nudging up or down
    let finalPos = this.getReelBandIndex(this._finalLandIndex);
    return this._currentInjectorPosition === finalPos;
  };

  //... and then clears the landing symbols once it has finished
  this.clearLandingSymbols = function () {
    this._landingSymbols = [];

    this._reelBandData = JSON.parse(JSON.stringify(this._reelBandDataTemp));
  };

  this.insertLandingSymbols = function (symsToSpin) {
    // Symbols inserted in reverse
    let reversedLandingSymbols = this._landingSymbols.slice().reverse();

    for (let i = 0; i < reversedLandingSymbols.length; i++) {
      let symbolReelBandIndex =
        this._startSpinInjectorPosition + symsToSpin + i;
      let finalPos = this.getReelBandIndex(
        symbolReelBandIndex - this._appertureSize
      );
      this._reelBandData[finalPos] = reversedLandingSymbols[i];

      this.checkLandingSymbolsRules(
        reversedLandingSymbols[i],
        finalPos,
        i,
        reversedLandingSymbols.length - i - 1
      );
    }

    this._finalLandIndex = this._startSpinInjectorPosition + symsToSpin;
    this._readyToLand = true;
  };

  // Jamie - temp for testing
  this.setReadyToLand = function (ready) {
    this._readyToLand = ready;
  };

  this.getReelBandIndex = function (index) {
    let length = this._reelBandData.length;
    let wrappedIndex = index % length;
    if (wrappedIndex < 0) {
      wrappedIndex += length;
    }
    return wrappedIndex;
  };

  /////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////
  this.checkRulesForValidSymbol = function () {
    let symbolData = this._symbolSelectionWT.pickOutcome();

    if (symbolData.rules === undefined) {
      return symbolData.outcome;
    } else {
      if (symbolData.rules.distance !== undefined) {
        let distance = symbolData.rules.distance;
        if (distance.count !== undefined) {
          for (let dist = 1; dist <= distance.count; dist++) {
            for (
              let sym = 0;
              sym < distance.symbolsToDistanceFrom.length;
              sym++
            ) {
              let symbolToCheck = distance.symbolsToDistanceFrom[sym];
              let symbolToCheckLeftIndex = this.getReelBandIndex(
                this._currentInjectorPosition - dist
              );
              let symbolToCheckRightIndex = this.getReelBandIndex(
                this._currentInjectorPosition + dist
              );
              let leftSym = this._reelBandData[symbolToCheckLeftIndex];
              let rightSym = this._reelBandData[symbolToCheckRightIndex];

              if (leftSym === symbolToCheck || rightSym === symbolToCheck) {
                // Symbol rules have been broken, pick a safe symbol
                return this._safeSymbolsWT.pickOutcome().outcome;
              }
            }
          }
        }
      }
      return symbolData.outcome;
    }
  };

  this.checkLandingSymbolsRules = function (
    symbol,
    checkPosition,
    crtIndex,
    maxIndex
  ) {
    let symbolData = this._symbolSelectionWT.getSymbolRule(symbol);

    if (symbolData?.distance === undefined) return;

    let distance = symbolData.distance;
    if (distance.count !== undefined) {
      for (let dist = 1; dist <= distance.count; dist++) {
        for (let sym = 0; sym < distance.symbolsToDistanceFrom.length; sym++) {
          let symbolToCheck = distance.symbolsToDistanceFrom[sym];
          let symbolToCheckLeftIndex = undefined;
          let symbolToCheckRightIndex = undefined;
          let leftSym = undefined;
          let rightSym = undefined;

          if (dist > crtIndex) {
            symbolToCheckLeftIndex = this.getReelBandIndex(
              checkPosition - dist
            );

            leftSym = this._reelBandData[symbolToCheckLeftIndex];
          }

          if (dist > maxIndex) {
            symbolToCheckRightIndex = this.getReelBandIndex(
              checkPosition + dist
            );

            rightSym = this._reelBandData[symbolToCheckRightIndex];
          }

          if (leftSym === symbolToCheck) {
            this._reelBandData[symbolToCheckLeftIndex] = this.getSafeSymbol();
          }

          if (rightSym === symbolToCheck) {
            this._reelBandData[symbolToCheckRightIndex] = this.getSafeSymbol();
          }
        }
      }
    }
  };
  /////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////

  Object.defineProperty(this, "remainingSymbols", {
    get: function () {
      return this._symbols.length;
    },
  });

  Object.defineProperty(this, "symbolsLastDrawn", {
    get: function () {
      return this.base.symbolsLastDrawn;
    },
    set: function (symbols) {
      let keys = Object.keys(symbols);
      for (let i = 0; i < keys.length; ++i) {
        this.base.symbolsLastDrawn[keys[i]] = symbols[keys[i]];
      }
    },
  });

  Object.defineProperty(this, "requiredSymbols", {
    get: function () {
      return this.base.requiredSymbols;
    },
    set: function (symbols) {
      this.base.requiredSymbols = symbols;
    },
  });

  Object.defineProperty(this, "bounceSymbols", {
    get: function () {
      return this._bounceSymbols;
    },
    set: function (symbols) {
      this._bounceSymbols = symbols;
    },
  });
  Object.defineProperty(this, "postSymbols", {
    get: function () {
      return this._postSymbols;
    },
    set: function (symbols) {
      this._postSymbols = symbols;
    },
  });
  Object.defineProperty(this, "hasLandingSymbols", {
    get: function () {
      return (
        this._landingData !== undefined &&
        this._landingData.landingSymbols !== undefined
      );
    },
  });
};
